import React, { useCallback, useLayoutEffect } from 'react';

import { useCart } from '../../hooks';
import type { CustomizationDeliveryEditScreenProps } from '../../navigation/AppNavigation.props';
import { DeliveryCustomization } from './components';

// ────────────────────────────────────────────────────────────────────────────────

export const CustomizationDeliveryEditScreen = (
  props: CustomizationDeliveryEditScreenProps,
) => {
  const { navigation, route } = props;

  const { addressId, productSlug, lineItemId } = route.params ?? {};

  const { cart } = useCart();

  // ─────────────────────────────────────────────────────────────────

  const navigateToBag = useCallback(() => {
    const previousRoutes = navigation.getState().routes;
    const previousRoute = previousRoutes.at(-2);

    // When navigating to the bag, if the bag is already in the stack, just return to it.
    if (navigation.canGoBack() && previousRoute?.name === 'Bag') {
      navigation.goBack();

      return;
    }

    navigation.replace('Bag');
  }, [navigation]);

  const navigateToCustomizationDelivery = useCallback(() => {
    navigation.replace('CustomizationDelivery', { addressId, productSlug });
  }, [addressId, navigation, productSlug]);

  // ─────────────────────────────────────────────────────────────────

  // redirect to the delivery customization screen if the line item isn't in the cart or has been removed
  useLayoutEffect(() => {
    const lineItems = cart?.lineItems;
    const isLineItemInCart = lineItems?.some(({ id }) => id === lineItemId);

    if (isLineItemInCart) {
      return;
    }

    navigateToCustomizationDelivery();
  }, [cart?.lineItems, lineItemId, navigateToCustomizationDelivery]);

  // ─────────────────────────────────────────────────────────────────

  return (
    <DeliveryCustomization
      addressId={addressId}
      productSlug={productSlug}
      lineItemId={lineItemId}
      isEditProductMode={true}
      onEditLineItemInCart={navigateToBag}
      onRemoveLineItemFromCart={navigateToBag}
    />
  );
};
